import { OrderStatus } from 'consts/order_statuses';

export const statusLabels = {
  [OrderStatus.PROCESSING]: 'Please accept the order',
  [OrderStatus.AWAITING_PAYMENT]: 'Awaiting payment from buyer',
  [OrderStatus.AWAITING_CONFIRMATION]: 'Please accept the order',
  [OrderStatus.AWAITING_SHIPMENT]: 'Delivered to Bezel',
  [OrderStatus.AWAITING_RECEIPT]: 'Please ship the watch',
  [OrderStatus.AWAITING_AUTH]: 'Delivered to Bezel',
  [OrderStatus.AWAITING_DELIVERY]: 'Delivered to Bezel',
  [OrderStatus.DELIVERED]: 'Delivered to Bezel',
  [OrderStatus.CANCELLED]: 'Order cancelled'
};

export const statusStyle = {
  border: '1px solid rgb(7, 116, 91, 0.6)',
  borderColor: 'rgb(7, 116, 91)',
  backgroundColor: 'rgba(7, 116, 91, 0.02)',
  color: 'rgb(7, 116, 91)'
};

export const cancelledStatusStyle = {
  border: '1px solid rgba(241, 94, 94, 0.6)',
  backgroundColor: 'rgba(241, 94, 94, 0.02)',
  color: 'rgb(241, 94, 94)'
};
